module.exports = __webpack_public_path__ + "img/pumping-activities-btn1.6af5997f.png";